import { CartPage } from '../pages/CartPage';

export function ResponsiveCartPage() {
  return <CartPage />;
}
